import { Injectable, inject } from '@angular/core';
import { NotificationService } from './notification.service';
import { TranslateService } from './translate.service';
import { TrackJS } from 'trackjs';

export const ERROR_STRINGS = {
  Unknown: 'Sorry, there was an unknown error.',
  RegisterInvalidCustomerName: 'Cannot register device, error: Invalid provider name.',
  RegisterMissingDescription: 'Cannot register device, error: Missing description.',
  RegisterUnknown: 'Cannot register device.',
  Timeout: 'The request has timed out, please try again.',
  ServerError: 'There was an unexpected error. Tech support has been notified',
  RequestError: 'There was an error in the request.',
  HttpErrorResponse: 'HttpErrorResponse',
  NetworkError: 'There was a network error. Please check your connection and try again.',
};

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  private notificationService = inject(NotificationService);
  private translateService = inject(TranslateService);

  handleError(error: Error, silent?: boolean): Promise<void> {
    TrackJS.console.info('handled error in global error handler');
    console.warn('handled error in global error handler', error);
    if (silent) { return; }
    const defaultError = this.translateService.translate('MESSAGE.genericError');
    this.notificationService.error(defaultError);
  }

  handleHttpError(error: ExtendedError) {

    TrackJS.console.info('handleHttpsError');
    //  debug and warn to prevent double tracking the error in TrackJS because the notification service already does
    TrackJS.console.debug(error);
    console.warn(error);

    if (error.error && error.error !== undefined) {
      return this.notificationService.error(`customerName: ${error.error?.CustomerName?.[0]}`, 0, true);
    }

    if (this.matchError(error, ERROR_STRINGS.ServerError)) {
      // special handling here
      return this.notificationService.error(ERROR_STRINGS.ServerError, 0, true);
    }

    if (
      this.matchError(error, ERROR_STRINGS.RequestError)
      || this.matchError(error, ERROR_STRINGS.HttpErrorResponse)
    ) {
      console.error(error.message);
      return this.notificationService.error(ERROR_STRINGS.RequestError);
    }

    if (
      error.message && error.message.toLowerCase().startsWith(`http failure response for`)
      || this.matchError(error, ERROR_STRINGS.NetworkError)
    ) {
      return this.notificationService.warning(ERROR_STRINGS.NetworkError);
    }

    const defaultError = this.translateService.translate('MESSAGE.genericError');
    return this.notificationService.error(defaultError);

  }

  matchError(e: Error, errorType) {
    return e.name === this.getErrorName(errorType);
  }

  createError(errorType): Error {
    const error = new Error(errorType);
    error.name = this.getErrorName(errorType);
    return error;
  }

  getErrorName(error): string {
    for (const i in ERROR_STRINGS) {
      if (ERROR_STRINGS[i] === error) {
        return i;
      }
    }
    return 'Unknown';
  }
}
///for API validation messages, must send ModelValidation error property "ValidationError" :["something"]
///put it here cause ¯\_(ツ)_/¯
class ExtendedError extends Error {
  error: { [key: string]: {} };
}
